import { render, staticRenderFns } from "./ConnectMCPIcon.vue?vue&type=template&id=453fbff8&scoped=true"
import script from "./ConnectMCPIcon.vue?vue&type=script&lang=js"
export * from "./ConnectMCPIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453fbff8",
  null
  
)

export default component.exports